// extracted by mini-css-extract-plugin
module.exports = {"sm":"576px","md":"768px","lg":"992px","feed-notice":"index-module__feed-notice___1-xo1","heading":"index-module__heading___2GH1D","text":"index-module__text___3RrDW"};